export const RESEARCH_TERMINAL_STATES = new Set(['completed', 'failed', 'cancelled']);

export const normalizedResearchSymbols = (symbols, candidate, maximum = 20) => {
  const next = [...new Set([...symbols, candidate].map((value) => String(value).trim().toUpperCase()).filter(Boolean))];
  return next.slice(0, maximum);
};

export const researchRangeError = ({ startDate, endDate, coverageStart, coverageEnd, maxYears = 8 }) => {
  if (!startDate || !endDate) return 'Choose a start and end date.';
  if (startDate < coverageStart || endDate > coverageEnd) return 'Choose dates within the verified dataset coverage.';
  if (startDate > endDate) return 'The start date must be on or before the end date.';
  const maximum = new Date(`${startDate}T00:00:00Z`);
  maximum.setUTCFullYear(maximum.getUTCFullYear() + maxYears);
  if (new Date(`${endDate}T00:00:00Z`) > maximum) return `Strategy Research supports at most ${maxYears} years.`;
  return '';
};

export const buildResearchRequest = ({ capabilities, symbols, strategyId, comparisonStrategyId, startDate, endDate, idempotencyKey }) => ({
  strategy_definition_id: strategyId,
  comparison_strategy_definition_id: comparisonStrategyId || null,
  snapshot_id: capabilities.snapshot.id,
  symbols,
  provider: capabilities.snapshot.provider,
  feed: capabilities.snapshot.feed,
  timeframe: capabilities.snapshot.timeframe,
  adjustment_basis: capabilities.snapshot.adjustment_basis,
  session_calendar: capabilities.snapshot.session_calendar,
  reporting_start_date: startDate,
  reporting_end_date: endDate,
  idempotency_key: idempotencyKey,
});

export const researchErrorMessage = (error) => {
  const code = error?.response?.data?.detail?.code;
  const messages = {
    strategy_research_disabled: 'Strategy Research is temporarily unavailable.',
    strategy_research_beta_required: 'Strategy Research is available to invited Premium beta members.',
    strategy_research_global_queue_full: 'Strategy Research is busy right now. There are 5 jobs waiting. Please try again when space becomes available.',
    strategy_research_active_job_limit: 'You already have a Strategy Research job in progress. Wait for it to finish or cancel it before starting another.',
    strategy_research_queue_limit: 'You already have a Strategy Research job in progress. Wait for it to finish or cancel it before starting another.',
    request_rate_limited: 'Too many Research requests. Please wait before trying again.',
  };
  return messages[code] || 'Strategy Research could not complete that request. Please review the fields and try again.';
};
